const primaryColor = "#e8f64b";
const secondaryColor = "#004952";
const primaryBgColor = "#e8f64b";
const thirdColor = "#11272a";
const baseUrl = process.env.REACT_APP_BASE_URL;
const testBaseUrl = "https://yehamukera.yehadigital.com/api/";
const token = localStorage.getItem("token");

export {
  primaryColor,
  secondaryColor,
  primaryBgColor,
  thirdColor,
  baseUrl,
  testBaseUrl,
  token,
};

